<div class="generales">
  <div fxLayout="row" fxLayoutAlign="center stretch" >
  <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
  </div>

  <div *ngIf="!cargando">
  <h1 class="titutlo">{{'SECCIONES.TABLERO_GLOBAL.TITULO' | translate}}</h1>

<div fxLayout="column" fxLayoutAlign="center center" >

<!-- <img src="assets/images/norm35/resuTest/NORMA35_DEMO_GLOBAL.jpg" alt=""> -->
<div fxLayout="row" fxLayoutAlign="space-around start" >

<div fxLayout="column" fxLayoutAlign="center center" class="tablas">

<!-- TABLA CATEGORÍA -->
<table mat-table [dataSource]="tablaCategoria" class="mat-elevation-z8">

  <ng-container matColumnDef="nombre">
    <th mat-header-cell *matHeaderCellDef style="background-color: #E0E0E0;"> {{'SECCIONES.TABLERO_GLOBAL.CATEGORIA' | translate}} </th>
    <td mat-cell *matCellDef="let element"
    [ngClass]=" element.valorColor == '4'? 'classAlto': 'classNulo'
    && element.valorColor == '2' ? 'classBajo': 'classNulo'
    && element.valorColor == '3' ? 'classMedio': 'classNulo'
    && element.valorColor == '5' ? 'classMuyAlto': 'classNulo'"> {{element.DimensionOrCategoryName}} <br> {{element.value}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> <br> <br>
</div>

<div  class="instrucciones">
  <table>
  <tr>
    <td style="background-color: #FF0000;">&nbsp; {{'SECCIONES.RANGOS.5' | translate}} &nbsp;</td>
    <td style="background-color: #FFFF00;">{{'SECCIONES.RANGOS.3' | translate}}</td>
  </tr>

  <tr>
    <td style="background-color: #FFC000;">{{'SECCIONES.RANGOS.4' | translate}}</td>
    <td style="background-color: #92D050;">{{'SECCIONES.RANGOS.2' | translate}}</td>
  </tr>

  <tr>
    <td style="background-color: #00b0f0;" colspan="2">{{'SECCIONES.RANGOS.1' | translate}}</td>
  </tr>
  </table>
  <p><strong>{{'SECCIONES.NOTATITULO' | translate}}</strong>{{'SECCIONES.TABLERO_GLOBAL.NOTA' | translate}}</p>
</div>
</div>

<!-- TABLA DOMINIO -->
<table mat-table [dataSource]="tablaDominio" class="mat-elevation-z8">

  <ng-container matColumnDef="nombre">
    <th mat-header-cell *matHeaderCellDef style="background-color: #E0E0E0;"> {{'SECCIONES.TABLERO_GLOBAL.DOMINIO' | translate}} </th>
    <td mat-cell *matCellDef="let element"
    [ngClass]=" element.valorColor == '4'? 'classAlto': 'classNulo'
    && element.valorColor == '2' ? 'classBajo': 'classNulo'
    && element.valorColor == '3' ? 'classMedio': 'classNulo'
    && element.valorColor == '5' ? 'classMuyAlto': 'classNulo'"> {{element.DimensionOrCategoryName}} <br> {{element.value}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> <br> <br>

<!-- TABLA DIMENSIÓN -->
<table mat-table [dataSource]="tablaDimension" class="mat-elevation-z8">

  <ng-container matColumnDef="nombre">
    <th mat-header-cell *matHeaderCellDef style="background-color: #E0E0E0;"> {{'SECCIONES.TABLERO_GLOBAL.DIMENSION' | translate}} </th>
    <td mat-cell *matCellDef="let element"> {{element.DimensionOrCategoryName}} <br> {{element.value}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

</div>
</div>
</div>
